<template>
  <div class="yp-wrap">
    <div class="yp-header yp-topbar yp-head-infor" v-show="!status.isSearch">
      <div class="yp-header-left"></div>
      <div class="yp-header-title">{{title}}</div>
      <div class="yp-header-right">
        <span @click="cancel">取消</span>
      </div>
    </div>
    <div class="yp-header yp-topbar yp-header-search" v-show="status.isSearch">
      <div class="yp-header-search-input">
        <div class="icon-sousuo-container">
          <i class="iconfont icon-sousuo"></i>
        </div>
        <div class="icon-guanbi-container" v-show="searchMemberList.search">
          <i class="iconfont icon-guanbi1" @click="searchMemberList.search = ''"></i>
        </div>
        <input v-model="searchMemberList.search" placeholder="按姓名或拼音搜索"/>
      </div>
      <div class="yp-header-cancel" @click="cancelSearch">
        取消
      </div>
    </div>
    <div v-show="searchMemberList.search" class="yp-main">
      <div class="yp-content-main search-content" @scroll="searchContentScroll">
        <ul>
          <li v-for="(item, index) in searchMemberList.data" @click="memberRowClick(item)">
            <div class="li-checkbox">
              <div class="checkbox-icon"
                   :class="{'selected': item.isSelected = status.selectedMemberId.indexOf(item.id)!==-1}">
              </div>
            </div>
            <img class="li-img" alt="" :src="item.avator"/>
            <div class="li-name">{{item.realName}}</div>
            <div class="li-right">{{item.phoneNumber}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div id="main" v-show="!searchMemberList.search" class="yp-main">
      <div class="yp-search" v-show="!status.isSearch">
        <div class="yp-search-input top-search" @click="status.isSearch = true">
          <i class="iconfont icon-sousuo"></i>
          <span>按姓名或拼音搜索</span>
        </div>
      </div>
      <div class="yp-menu">
        <div class="yp-menu-list" v-for="(item, index) in menuList" :key="index" v-show="!status.triggerCrumbs">
          <i class="yp-menu-icon iconfont" :class="item.icon"></i>
          <div class="yp-menu-content" @click="item.event">{{item.menuName}}</div>
        </div>
        <div class="yp-menu-crumbs" v-show="status.triggerCrumbs">
          <crumbs :routes="crumbs.routes" :crumbTrigger="crumbs.crumbTrigger"></crumbs>
        </div>
      </div>
      <div class="yp-content-title" v-show="status.isAllMember">联系人</div>
      <div id="memberListContent" class="yp-content" v-show="status.isAllMember" @scroll="memberListScroll">
        <div class="yp-ul-noData" v-show="!memberList.data.length">暂无数据</div>
        <div class="yp-content-main">
          <ul>
            <li v-for="(item, index) in memberList.data" @click="memberRowClick(item)">
              <div class="li-checkbox">
                <div class="checkbox-icon"
                     :class="{'selected': item.isSelected = status.selectedMemberId.indexOf(item.id)!==-1}">
                </div>
              </div>
              <img class="li-img" alt="" :src="item.avator"/>
              <div class="li-name">{{item.realName}}</div>
              <div class="li-right">{{item.phoneNumber}}</div>
            </li>
          </ul>
        </div>
      </div>
      <div class="yp-content" v-show="!status.isAllMember && status.isSelectDept">
        <div class="yp-content-main">
          <ul>
            <li v-for="(item, index) in deptList.renderData">
              <div class="li-name">{{item.orgName}}</div>
              <div class="li-right li-link">
                <a @click.stop="deptExpend(item)">展开
                </a>
                <a @click.stop="nextDept(item)" v-show="item.children.length">下级
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div id="groupListContent" class="yp-content" v-show="!status.isAllMember && !status.isSelectDept" @scroll="groupListScroll">
        <div class="yp-content-main">
          <ul>
            <li v-for="(item, index) in groupList.renderData">
              <div class="li-name">{{item.groupName}}</div>
              <div class="li-right li-link"><a @click.stop="groupExpend(item)">展开</a></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="yp-footer">
      <span>已选择{{status.selectedMemberId.length}}个</span>
      <button class="confirm-button" :class="{'disabled': !status.selectedMemberId.length}"
              :disabled="!status.selectedMemberId.length" @click="confirm">
        确定（{{status.selectedMemberId.length}}/{{constant.maxSelect}}）
      </button>
    </div>
    <div class="shade" v-show="status.isSearch&&!searchMemberList.search"></div>
  </div>
</template>
<script>
  import crumbs from '@/components/crumbs'
  import apis from '@/apis/cloudStorageApi'
  import ajax from '@/apis/index'
  import {Toast} from 'mint-ui'

  export default {
    data () {
      return {
        title: this.eleTitle || '添加新成员',
        searchMemberList: {
          search: '',
          data: [],
          pageNo: 0,
          totalElements: 0
        },
        constant: { // 常量对象
          maxSelect: 100,
          pageSize: 20 // 每次加载数据的条数
        },
        deptList: {
          pageNo: 0,
          totalElements: 0,
          data: [],
          renderData: [],
          cacheClick: {} // 缓存点击过的子集部门节点
        },
        groupList: {
          pageNo: 0,
          totalElements: 0,
          renderData: []
        },
        crumbs: {
          routes: [{
            name: '所有成员',
            id: -1
          }],
          // 点击面包屑触发
          crumbTrigger: (route) => {
            if (route.id === -1) { // 点击所有成员
              this.status.triggerCrumbs = false
              this.status.isAllMember = true
              this.crumbs.routes = [{
                name: '所有成员',
                id: -1
              }]
              this.allMemberListInit()
              this.status.scrollObj = 1 // 成员列表滚动条出现时加载成员为所有成员
            } else if (route.id === -2) { // 点击组织架构方向
              if (this.status.isAllMember) {
                this.status.isAllMember = false
              }
              this.deptList.renderData = this.deptList.data
            } else if (route.id === -3) { // 点击群组方向
              if (this.status.isAllMember) {
                this.status.isAllMember = false
              }
            } else if (route.type === 'dept') {
              if (this.status.isAllMember) {
                this.status.isAllMember = false
              }
              this.deptList.renderData = this.deptList.cacheClick[route.id]
            }
          }
        },
        menuList: [
          {
            icon: 'icon-bumenguanli',
            menuName: '从部门架构中选择',
            event: () => {
              this.status.isAllMember = false
              this.status.triggerCrumbs = true
              this.status.isSelectDept = true
              this.status.scrollObj = 2  // 成员列表滚动时加载的数据为部门成员
              this.crumbs.routes.push({
                name: '部门架构',
                id: -2
              })
              ajax.request(apis.deptList).then((response) => {
                this.deptList.renderData = this.deptList.data = response.data
              })
            }
          }, {
            icon: 'icon-qunzuguanli',
            menuName: '从群组中选择',
            event: () => {
              this.status.isAllMember = false
              this.status.triggerCrumbs = true
              this.status.isSelectDept = false
              this.status.scrollObj = 3  // 成员列表滚动时加载的数据为群组成员
              this.crumbs.routes.push({
                name: '群组',
                id: -3
              })
              this.groupList = {
                pageNo: 0,
                totalElements: 0,
                renderData: []
              }
              this.queryGroupList()
            }
          }
        ],
        memberList: {
          pageNo: 0,
          totalElements: 0,
          data: []
        },
        status: {// 保存页面状态
          isSearch: false,
          selectedMemberId: [],
          triggerSelect: false,
          triggerCrumbs: false,
          isAllMember: true,
          isSelectDept: true,
          scrollObj: 1, // 成员列表是根据群组或部分或全部
          clickDeptOrGroup: 0 // 当前点击的群组或部门
        },
        dataListMember: this.dataList || [],
        removeId: ''
      }
    },
    computed: {
      isAllMember () {
        return this.status.isAllMember
      },
      isSearch () {
        return this.status.isSearch
      },
      search () {
        return this.searchMemberList.search
      }
    },
    watch: {
      isAllMember () {
        this.conputeContentPos()
      },
      isSearch () {
        this.conputeContentPos()
      },
      search () {
        this.searchMemberList.data = []
        this.searchMemberList.totalElements = 0
        this.searchMemberList.pageNo = 0
        if (!this.search) {
          return false
        }
        this.searchMember()
      }
    },
    created () {
      this.allMemberListInit()
      this.dataListMember.forEach((ele, index) => {
        this.status.selectedMemberId.push(ele.id)
      })
      this.removeId = JSON.parse(window.sessionStorage.mobileData).id
    },
    components: {
      crumbs
    },
    props: ['cancelOperation', 'confirmOperation', 'eleTitle', 'dataList', 'isFilter'],
    methods: {
      cancel () {
        if (typeof this.cancelOperation === 'function') {
          window.history.back()
          new Promise((resolve, reject) => {
            setTimeout(() => {
              this.cancelOperation(resolve, reject)
              resolve()
            })
          }).then(() => {
            this.clearStatus()
          })
        }
      },
      confirm () {
        if (typeof this.confirmOperation === 'function') {
          new Promise((resolve, reject) => {
            setTimeout(() => {
              this.confirmOperation(this.status.selectedMemberId, resolve, reject)
              resolve()
            })
          }).then(() => {
            this.clearStatus()
          })
        }
      },
      clearStatus () {
        this.status.selectedMemberId = []
        this.status.isSearch = false
        this.status.triggerSelect = false
        this.status.triggerCrumbs = false
        this.status.isAllMember = true
        this.status.isSelectDept = true
        this.status.clickDeptOrGroup = 0
        this.status.scrollObj = 1
      },
      queryGroupList () {
        ajax.request(apis.groupList, {
          page: this.groupList.pageNo,
          size: this.constant.pageSize
        }).then((response) => {
          this.groupList.renderData = this.groupList.renderData.concat(response.data.content)
          this.groupList.totalElements = response.data.totalElements
        })
        this.groupList.pageNo++
      },
      // 搜索成员
      searchMember () {
        var _this = this
        ajax.request(apis.allMemberList, {
          page: this.searchMemberList.pageNo,
          size: this.constant.pageSize,
          info: this.searchMemberList.search
        }).then((response) => {
          response.data.content.forEach(function (val, index) {
            if (!_this.isFilter && val.id === _this.removeId) {
              response.data.content.splice(index, 1)
            }
          })
          this.searchMemberList.data = this.searchMemberList.data.concat(response.data.content)
          this.searchMemberList.totalElements = response.data.totalElements
        })
        this.searchMemberList.pageNo++
      },
      // 取消搜索
      cancelSearch () {
        this.status.isSearch = false
        this.searchMemberList.search = ''
      },
      // 计算下方内容列表区的定位
      conputeContentPos () {
        setTimeout(() => {
          let node = document.getElementById('memberListContent')
          while ((node = node.previousElementSibling).style.display === ('' || 'none')) {
          }
          Array.prototype.forEach.call(document.getElementsByClassName('yp-content'), (value) => {
            value.style.top = node.offsetHeight + node.offsetTop + 'px'
          })
        })
      },
      // 搜索区域卷起
      searchContentScroll () {
        const content = document.getElementsByClassName('search-content')[0]
        if (content.scrollHeight - content.scrollTop - content.offsetHeight < 10) {
          if (this.searchMemberList.totalElements > this.searchMemberList.data.length) {
            this.searchMember()
          }
        }
      },
      // 成员列表div滚动时
      memberListScroll () {
        const memberListContent = document.getElementById('memberListContent')
        if (memberListContent.scrollHeight - memberListContent.scrollTop - memberListContent.offsetHeight < 10) {
          if (this.memberList.totalElements > this.memberList.data.length) {
            if (this.status.scrollObj === 1) {
              this.queryAllMemberList()
            } else if (this.status.scrollObj === 2) {
              this.queryMemberListByDept(this.status.clickDeptOrGroup)
            } else if (this.status.scrollObj === 3) {
              this.queryMemberListByGroup(this.status.clickDeptOrGroup)
            }
          }
        }
      },
      // 群组列表div滚动时
      groupListScroll () {
        const groupListContent = document.getElementById('groupListContent')
        if (groupListContent.scrollHeight - groupListContent.scrollTop - groupListContent.offsetHeight < 10) {
          if (this.groupList.totalElements > this.groupList.renderData.length) {
            this.queryGroupList()
          }
        }
      },
      // 查询所有成员列表并初始化配置
      allMemberListInit () {
        this.memberList = {
          pageNo: 0,
          totalElements: 0,
          data: []
        }
        this.queryAllMemberList()
      },
      queryAllMemberList () {
        var _this = this
        ajax.request(apis.allMemberList, {
          page: this.memberList.pageNo,
          size: this.constant.pageSize
        }).then((response) => {
          response.data.content.forEach(function (val, index) {
            if (!_this.isFilter && val.id === _this.removeId) {
              response.data.content.splice(index, 1)
            }
          })
          this.memberList.data = this.memberList.data.concat(response.data.content)
          this.memberList.totalElements = response.data.totalElements
        })
        this.memberList.pageNo++
      },
      queryMemberListByDept (id) {
        var _this = this
        ajax.request(apis.memberListByDept, {
          orgId: id,
          page: this.memberList.pageNo,
          size: this.constant.pageSize
        }).then((response) => {
          this.status.isAllMember = true
          response.data.content.forEach(function (val, index) {
            if (!_this.isFilter && val.id === _this.removeId) {
              response.data.content.splice(index, 1)
            }
          })
          this.memberList.data = this.memberList.data.concat(response.data.content)
          this.memberList.totalElements = response.data.totalElements
        })
        this.memberList.pageNo++
      },
      queryMemberListByGroup (id) {
        var _this = this
        ajax.request(apis.memberListByGroup, {
          groupId: id,
          page: this.memberList.pageNo,
          size: this.constant.pageSize
        }).then((response) => {
          this.status.isAllMember = true
          response.data.content.forEach(function (val, index) {
            if (!_this.isFilter && val.id === _this.removeId) {
              response.data.content.splice(index, 1)
            }
          })
          this.memberList.data = response.data.content
          this.memberList.totalElements = response.data.totalElements
        })
        this.memberList.pageNo++
      },
      // 群组展开
      groupExpend (item) {
        this.memberList = {
          pageNo: 0,
          totalElements: 0,
          data: []
        }
        this.status.clickDeptOrGroup = item.id
        this.queryMemberListByGroup(item.id)
        this.crumbs.routes.push({
          name: item.groupName,
          id: item.id,
          type: 'group'
        })
      },
      // 下一级部门
      nextDept (item) {
        this.deptList.renderData.some((value, index, array) => {
          if (value.id === item.id) {
            this.crumbs.routes.push({
              name: item.orgName,
              id: item.id,
              type: 'dept'
            })
            if (!(item.id in this.deptList.cacheClick)) {
              this.deptList.cacheClick[item.id] = value.children
            }
            this.deptList.renderData = value.children
            return true
          }
          return false
        })
      },
      // 部门列表下级按钮点击
      deptExpend (item) {
        this.crumbs.routes.push({
          name: item.orgName,
          id: item.id,
          type: 'dept'
        })
        this.memberList = {
          pageNo: 0,
          totalElements: 0,
          data: []
        }
        this.status.clickDeptOrGroup = item.id
        this.queryMemberListByDept(item.id)
      },
      // 成员列表行点击
      memberRowClick (item) {
        if (!item.isSelected) {
          if (this.status.selectedMemberId.length >= this.constant.maxSelect) {
            Toast({
              message: '已达到人数限制',
              iconClass: 'icon-error'
            })
            return false
          }
          this.status.selectedMemberId.push(item.id)
        } else {
          this.status.selectedMemberId.splice(this.status.selectedMemberId.indexOf(item.id), 1)
        }
        item.isSelected = !item.isSelected
      }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../assets/css/variable";

  .yp-wrap {
    text-align: left;
    width: 100vw;
    height: 100vh;
    background-color: #F7F7FA;
    position: relative;
    overflow: hidden;
    .yp-header-search {
      padding: 0.57rem 0.18rem 0.15rem 0.16rem;
      .yp-header-search-input {
        height: 100%;
        display: inline-block;
        position: relative;
        .icon-sousuo-container {
          position: absolute;
          height: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 0.51rem;
          .icon-sousuo {
            color: #B2B2B2;
            font-size: 0.25rem;
          }
        }
        .icon-guanbi-container{
          position: absolute;
          height: 100%;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 0.51rem;
          right: 0;
          .icon-guanbi1{
            color: #B2B2B2;
            font-size: 0.25rem;
          }
        }
        input{
          width: 6.34rem;
          height: 100%;
          background: $white;
          border: 0.01rem solid #E6E6EA;
          border-radius: 0.1rem;
          padding-left: 0.51rem;
        }
      }
    }
    .yp-head-infor {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: space-between;
      color: $white;
      padding: 0 0.32rem 0.22rem 0.24rem;
    }
    .yp-header {
      z-index: 1000;
      position: absolute;
      top: 0;
      height: 1.28rem;
      width: 100%;
      .yp-header-cancel {
        display: inline-block;
        font-family: PingFangSC-Regular;
        font-size: 0.32rem;
        color: $white;
        letter-spacing: 0;
        margin-right: 0;
        margin-left: auto;
      }
      .yp-header-left {
        width: 2rem;
        text-align: left;
      }
      .yp-header-title {
        font-family: PingFangSC-Medium;
        font-size: $fontsize-lg;
        letter-spacing: 0;
        width: 2rem;
        overflow: hidden;
      }
      .yp-header-right {
        width: 2rem;
        text-align: right;
        span {
          font-family: PingFangSC-Regular;
          font-size: 0.32rem;
          color: $white;
          letter-spacing: 0;
        }
        i {
          font-size: 0.46rem;
          &:first-child {
            margin-right: 0.5rem;
          }
        }
      }
    }
    .yp-main {
      position: absolute;
      width: 100%;
      top: 1.28rem;
      bottom: 0.98rem;
      overflow: hidden;
      .yp-search {
        padding: 0.16rem;
        .top-search {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          color: #B2B2B2;
          letter-spacing: 0.0028rem;
          height: 0.56rem;
          width: 100%;
        }
      }
      .yp-menu {
        padding-bottom: 0.24rem;
        .yp-menu-crumbs {
          width: 100%;
          background-color: $white;
        }
        .yp-menu-list {
          background: $white;
          height: 0.88rem;
          position: relative;
          &:not(:last-child) {
            .yp-menu-content {
              border-bottom: 0.01rem solid #E5E5E5;;
            }
          }
          .yp-menu-icon {
            text-align: center;
            display: inline-block;
            width: 0.76rem;
            font-size: 0.28rem;
            height: 100%;
            line-height: 0.88rem;
          }
          .yp-menu-content {
            display: inline-block;
            height: 100%;
            position: absolute;
            left: 0.76rem;
            right: 0;
            line-height: 0.88rem;
            font-family: PingFangSC-Regular;
            font-size: $fontsize-md;
            color: #000000;
            letter-spacing: 0;
          }
        }
      }
      .yp-content-title {
        padding-left: 0.24rem;
        height: 0.76rem;
        line-height: 0.76rem;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #999999;
        border-bottom: 0.01rem solid #E5E5E5;
        background-color: $white;
      }
      .yp-content {
        background-color: $white;
        width: 100%;
        position: absolute;
        bottom: 0;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 0px;
          opacity: 0;
          -webkit-overflow-scrolling: touch;
        }
        top: 3.64rem;
        .yp-ul-noData {
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 0.28rem;
          color: #41464D;
        }
      }
      .yp-content-main {
        ul {
          li {
            font-family: PingFangSC-Regular;
            position: relative;
            font-size: $fontsize-md;
            color: #1D1F22;
            letter-spacing: 0;
            height: 1.1rem;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 0.01rem solid #E5E5E5;;
            > img, div {
              display: inline-block;
            }
            .li-checkbox {
              width: 0.81rem;
              position: relative;
              height: 100%;
              .selected {
                background: url(../assets/images/success_big.png) center no-repeat;
                background-size: 0.24rem 0.24rem;
                border: none;
              }
              .checkbox-icon {
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                margin: auto;
                width: 0.24rem;
                height: 0.24rem;
                border-radius: 50%;
                border: 0.01rem solid #979797;
              }
            }
            .li-img {
              width: 0.64rem;
              height: 0.64rem;
              background-size: 100% 100%;
              background-image: url('../assets/images/defaultPic.png');
              background-repeat: no-repeat;
            }
            .li-name {
              padding: 0 0.2rem;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 3.8rem;
            }
            .li-right {
              padding-right: 0.2rem;
              margin-right: 0;
              margin-left: auto;
              font-family: PingFangSC-Regular;
              font-size: 0.28rem;
              letter-spacing: 0;

            }
            .li-link {
              color: #E4393C;
            }
          }
        }
      }
      .search-content{
        position: absolute;
        top: 0;
        width: 100%;
        bottom: 0;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 0px;
          opacity: 0;
          -webkit-overflow-scrolling: touch;
        }
      }
    }
    .yp-footer {
      position: absolute;
      height: 0.98rem;
      width: 100%;
      bottom: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 0.24rem;
      > span {
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #E4393C;
      }
      .confirm-button {
        background: #E4393C;
        border-radius: 0.1rem;
        padding: 0.15rem 0 0.15rem 0.24rem;
        border-radius: 0.1rem;
        margin-right: 0;
        margin-left: auto;
        border: 0;
        font-family: PingFangSC-Regular;
        font-size: $fontsize-lg;
        color: $white;
      }
    }
    .shade {
      position: absolute;
      width: 100%;
      top: 1.28rem;
      bottom: 0;
      opacity: 0.5;
      background-color: #000000;
      z-index: 10000;
    }
  }

  .yp-search-input {
    background: $white;
    border: 0.01rem solid #E6E6EA;
    border-radius: 0.1rem;
  }

  .icon-bumenguanli {
    color: #3697F5;
  }

  .icon-qunzuguanli {
    color: #2AB75A;
  }

  .disabled {
    background: rgba(228,57,60,0.50) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/addmember.vue